import Icon from '../components/Icon.vue'

Icon.register({"user-alt-slash":{"width":640,"height":512,"paths":[{"d":"M633.8 458.1L389.6 269.3C433.8 244.7 464 198.1 464 144 464 64.5 399.5 0 320 0 252.9 0 197 46.1 181 108.2L45.5 3.4C38.5-2 28.5-0.8 23 6.2L3.4 31.4C-2 38.4-0.8 48.4 6.2 53.8L594.6 508.5C601.6 513.9 611.6 512.7 617.1 505.7L636.7 480.4C642.1 473.6 640.8 463.5 633.8 458.1zM198.4 320C124.2 320 64 380.2 64 454.4V464C64 490.5 85.5 512 112 512H494.2L245.8 320H198.4z"}]}})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/user-alt-slash.js
// module id = 32cs
// module chunks = 0